import React from 'react';
import { Modal } from './Modal';
import './PaymentRestrictionsModal.css';

export interface PaymentRestrictionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaymentRestrictionsModal: React.FC<PaymentRestrictionsModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="payment-restrictions-modal"
      title={'Почти как на заправке —\nне больше 20 в одни руки.'}
    >
      <div className="payment-restrictions-modal-content">
        <div className="payment-restrictions-modal-description">
          <p className="payment-restrictions-modal-text">
            Только у нас вместо бензина — Ху#ки 😄
          </p>

          <p className="payment-restrictions-modal-text">
            Банки ограничивают оплату <strong>после 20 успешных продаж в день</strong> на
            один номер СБП. Также замечаем, что банк покупателя может ограничивать списание
            уже после 2 успешных оплат.
          </p>

          <div className="payment-restrictions-modal-text">
            Если платёж не проходит:
            <ul className="payment-restrictions-modal-list payment-restrictions-modal-list--accent">
              <li>используйте другой банк;</li>
              <li>смените номер СБП;</li>
              <li>попробуйте другого продавца.</li>
            </ul>
          </div>

          <p className="payment-restrictions-modal-text">
            Возможны и другие банковские ограничения — если один способ не помог, попробуйте
            следующий.
          </p>
        </div>

        <div className="payment-restrictions-modal-actions">
          <button
            className="payment-restrictions-modal-button"
            onClick={onClose}
          >
            Понятно
          </button>
        </div>
      </div>
    </Modal>
  );
};
